import { useBatchedSimpleDutyRosterPeriodStatuses } from "@/-dataloaders/simple-duty-roster-period-statuses"
import { Badge, BadgeProps } from "@mantine/core"
interface Props extends BadgeProps {
  statusId: number
}
export function DutyRosterPeriodStatusBadge({
  statusId,
  ...badgeProps
}: Props) {
  const { data: status } = useBatchedSimpleDutyRosterPeriodStatuses(statusId)
  return (
    <Badge color={status?.colorHex} {...badgeProps}>
      {status?.name}
    </Badge>
  )
}
